export default {
    "/": {
        "title": "Taoify - Plataforma de criação de lojas independentes para comércio eletrônico transfronteiriço | Produtos chineses, vendidos globalmente",
        "desc": "Taoify reúne a criação de sites, tradução, listagem, logística, pagamentos e marketing em um único painel: 18 funcionários AI trabalhando para você, abra sua loja em 20 idiomas e venda produtos chineses ao redor do mundo."
    },
    "/feature": {
        "title": "Funcionalidades · Tudo que você precisa para abrir uma loja, está nesta página · Taoify",
        "desc": "Criação de sites, tradução, listagem, envio, pagamento, atração de clientes — Taoify coloca 15 módulos necessários para vender internacionalmente em um único painel, sem a necessidade de usar várias ferramentas externas."
    },
    "/ai-staff": {
        "title": "Funcionários AI · 18 funcionários AI, os mais ocupados são os que geram tráfego · Taoify",
        "desc": "Dentre os 18 funcionários AI, 5 da equipe de crescimento se concentram em resolver o problema de \"não ter visitantes\": 12 itens de diagnóstico da loja, 30 dias de planos de marketing, reescrita de um produto para 9 canais diferentes, e-mails de marketing automáticos para trazer de volta os clientes antigos."
    },
    "/logistics": {
        "title": "Logística transfronteiriça · Do seu estoque até as mãos do cliente · Taoify",
        "desc": "Primeira etapa, despacho aduaneiro, transporte principal, entrega final, três rotas disponíveis para escolher de acordo com o tipo de mercadoria e prazo. Yuntu, Yanwen e 4PX já estão integrados, rastreamento, etiquetas e tratamento de exceções tudo em um único painel."
    },
    "/payment": {
        "title": "Pagamentos e liquidação · O cliente paga como preferir · Taoify",
        "desc": "PayPal, Stripe, cartões de crédito, Alipay, conecte e use imediatamente. Receba em moeda estrangeira, saque em RMB, liquidação T+7, taxas e tempo de recebimento claramente especificados."
    },
    "/pricing": {
        "title": "Preços · Planos de assinatura + comissão escalonada · Taoify",
        "desc": "As lojas são cobradas por pacotes de assinatura: básico $15/mês, padrão $29/mês, premium $59/mês, economize ainda mais com pagamentos trimestrais ou anuais. A comissão de transação varia conforme o volume mensal, com um mínimo de 3%."
    },
    "/cases": {
        "title": "Casos de Sucesso · Eles também estão fazendo a mesma coisa · Taoify",
        "desc": "Vendedores de bijuterias de Yiwu, eletrônicos 3C de Shenzhen, roupas de Guangzhou, e vendedores da Alemanha, EUA e França - seis pessoas, seis origens, o mesmo método."
    },
    "/sign-up": {
        "title": "Abra sua Loja - Cadastro Grátis no Taoify",
        "desc": "Monte seu site de marca em 10 minutos, sem código, com teste completo de todos os recursos. Registre-se agora no Taoify e inicie sua jornada no comércio eletrônico internacional."
    },
    "/for-china-sellers": {
        "title": "Para Vendedores Chineses · Você escolhe os produtos e define os preços, nós cuidamos do resto · Taoify",
        "desc": "Criação de lojas, tradução, frete, impressão de etiquetas, atendimento ao cliente - a plataforma faz tudo isso por você. Assinatura + comissão escalonada (a partir de 3%)."
    },
    "/for-global-sellers": {
        "title": "Para Vendedores Internacionais: Escolha seus produtos nas prateleiras chinesas e venda em sua própria loja · Taoify",
        "desc": "Sem estoque ou armazenamento: selecione produtos da cadeia de suprimentos chinesa, envie diretamente do armazém na China após a compra do cliente, e ganhe a diferença. O BuyLink ainda pode transformar links 1688 e Taobao em seus próprios produtos."
    },
    "/template-index": {
        "title": "Mercado de Modelos - Temas Profissionais para Sites do Taoify",
        "desc": "Modelos profissionais de sites para qualquer projeto, com uma vasta gama de templates gratuitos por setor, personalizáveis conforme suas necessidades de imagem e funcionalidade."
    },
    "/question": {
        "title": "Centro de Ajuda · Encontre as respostas aqui primeiro · Taoify",
        "desc": "Abertura de loja, design, listagem de produtos, logística, pagamentos, marketing, permissões de conta - perguntas frequentes organizadas por categoria, abra um ticket se não encontrar a resposta."
    },
    "/about-us": {
        "title": "Sobre o Taoify · O que estamos fazendo",
        "desc": "Taoify é uma plataforma de criação de sites integrada para vendedores internacionais: construção de sites, tradução, listagem de produtos, logística, pagamentos e marketing, tudo em um único painel."
    },
    "/privacy-policy": {
        "title": "Política de Privacidade · Taoify",
        "desc": "Como o Taoify coleta, usa, armazena e protege suas informações pessoais, bem como os direitos que você tem sobre seus dados."
    },
    "/terms-service": {
        "title": "Termos de Serviço · Taoify",
        "desc": "Termos e condições para o uso dos serviços da plataforma Taoify: contas, lojas, pedidos, pagamento e divisão de responsabilidades."
    },
    "/consumer-agreement": {
        "title": "Política de Reembolso · Taoify",
        "desc": "Regras de reembolso e pós-venda para pedidos na plataforma Taoify: condições de solicitação, prazos de processamento e métodos de recebimento."
    },
    "/user-agreement": {
        "title": "Termos de Uso · Taoify",
        "desc": "Antes de se registrar e usar o Taoify, leia atentamente: instruções para registro de conta, regulamentos para operação da loja e descrição dos serviços da plataforma."
    }
}
